import { Fragment } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { TodoNavbar } from './components/Navbar';

import { Todo } from './index';

export const TodoRoutes = (): JSX.Element => (
    <Fragment>
        <TodoNavbar />
        <Routes>
            <Route path=":period" element={<Todo />} />
            <Route path="*" element={<Navigate to="today" replace />} />
        </Routes>
    </Fragment>
);
